<template>
  <div v-if="userData" class="my-4">
    <h2 class="green--text">Profildaten bearbeiten | Name, Adresse ....</h2>

    <v-form @submit.prevent="updateUserData">
      <v-text-field
        v-model="userData.user_firma"
        label="Praxis"
        type="text"
        required
      ></v-text-field>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="userData.user_vorname"
            label="Vorname"
            type="text"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="userData.user_name"
            label="Name"
            type="text"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="10">
          <v-text-field
            v-model="userData.user_strasse"
            label="Straße"
            type="text"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="userData.user_hsnr"
            label="Hsnr."
            type="text"
          ></v-text-field>
        </v-col>
      
      </v-row>
      <v-row>
        <v-col cols="12" md="2">
          <v-text-field
            v-model="userData.user_plz"
            label="PLZ" 
            type="text"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="10">
          <v-text-field
            v-model="userData.user_ort"
            label="Ort"
            type="text" 
          ></v-text-field>
        </v-col>
       
      </v-row>
  
      
      <v-btn type="submit" color="primary">
        Daten jetzt aktualisieren
      </v-btn>
    </v-form>
  </div>
</template>

<script setup>
import {   inject } from "vue";
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/userStore';
const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore')
const errorStore = inject('errorStore');
const successStore = inject('successStore');

const userStore = useUserStore();
const { userData } = storeToRefs(userStore);


async function updateUserData() {
  loaderStore.setLoader(true, "Daten werden aktualisiert...");
  
  try {
    const payload = {
      ...userData.value,
      action: 'updateuser'
    };
    
    const response = await baseCalls.userPost(payload);
    
    if (response.data && response.data.success) {
      successStore.setSuccess(
        true,
        "Gespeichert",
        "Ihre Daten wurden erfolgreich aktualisiert"
      );
    } else {
      throw new Error(response.data.message || "Fehler beim Aktualisieren der Daten");
    }
  } catch (err) {
    errorStore.setError(
      err.message || "Beim Speichern Ihrer Daten ist ein Fehler aufgetreten"
    );
    console.error("Fehler beim Aktualisieren des Benutzers:", err);
  } finally {
    loaderStore.setLoader(false);
  }
}

</script>
